export default {
    'shoppingNote.title': 'お買い物のご案内',
} as Record<string, string>;